import { http } from '../services';

class PaginaService {
    paginaForm() {
        return http.get('/paginas/form');
    }

    async getAll({
        pageIndex,
        rowsPerPage,
        columnSort,
        orderSort,
        searchIndex,
        searchText,
        searchOperator,
    }) {
        return http.get('/paginas', {
            pageIndex,
            rowsPerPage,
            columnSort,
            orderSort,
            searchIndex,
            searchText,
            searchOperator,
        });
    }

    async getCount({ searchIndex, searchText, searchOperator }) {
        return http.get('/paginas/count', {
            searchIndex,
            searchText,
            searchOperator,
        });
    }

    getNiveisAcesso(nome) {
        return http.get(`/paginas/niveis-acesso/${nome}`);
    }

    getPagina(codigo) {
        return http.get(`/paginas/${codigo}`);
    }

    save(pagina) {
        return http.post('/paginas', pagina);
    }

    update(pagina) {
        return http.put('/paginas', pagina);
    }

    delete(pagina) {
        return http.delete('/paginas', pagina);
    }
}

const paginaService = new PaginaService();
export default paginaService;
